import React from 'react'

import {css} from '../../theme/css'
import {createSvgIcon} from '../utils'

const root = css`
  block-size: 32px;
  inline-size: 162px;
  mask-type: alpha;
`

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_17047_193869)">
      <mask
        height="29"
        id="mask0_17047_193869"
        maskUnits="userSpaceOnUse"
        width="29"
        x="0"
        y="2"
      >
        <circle cx="14.0026" cy="16.4999" fill="white" r="14.0026" />
      </mask>
      <g mask="url(#mask0_17047_193869)">
        <rect
          fill="#FC3F1D"
          height="28.0052"
          transform="translate(0 2.49731)"
          width="28.0052"
        />
        <path
          d="M14.3837 17.9464C15.202 19.7388 15.4747 20.3622 15.4747 22.5149V25.369H12.5524V20.557L7.03906 8.56592H10.088L14.3837 17.9464ZM17.9879 8.56592L14.413 16.6899H17.3839L20.9686 8.56592H17.9879Z"
          fill="white"
        />
      </g>
    </g>
    <g clipPath="url(#clip1_17047_193869)">
      <rect
        fill="#5C5A57"
        fillOpacity="0.1"
        height="28"
        rx="14"
        width="28"
        x="33.1172"
        y="2.5"
      />
      <g clipPath="url(#clip2_17047_193869)">
        <path
          d="M32.1367 8.73007L44.3867 4.32007L56.6367 8.73007V24.4101L44.3867 28.8201L32.1367 24.4101V8.73007Z"
          fill="#FF7751"
        />
        <path
          d="M32.1367 8.72998L44.3867 13.14V28.82L32.1367 24.41V8.72998Z"
          fill="#E13100"
        />
        <path
          d="M56.6367 8.72998L44.3867 13.14V28.82L56.6367 24.41V8.72998Z"
          fill="#FC4714"
        />
        <path
          d="M55.2891 21.6008C52.659 24.1485 48.4404 25.6052 45.7344 25.0784V23.7004C48.3859 24.2412 52.64 22.9195 55.2891 20.2219V21.6008ZM49.8604 17.5764L48.9912 17.8928V21.5901L46.8203 22.3801V18.6829L45.9512 18.9993L47.9053 13.6663L49.8604 17.5764ZM55.0713 15.6799L54.2031 15.9954V19.6926L52.0312 20.4836V16.7864L51.1631 17.1018L53.1172 11.7688L55.0713 15.6799Z"
          fill="white"
        />
      </g>
    </g>
    <path
      d="M67.5087 7.73282H71.6757C72.8346 7.73282 73.9168 7.8862 74.9223 8.19297C75.9279 8.49975 76.7885 8.99399 77.5043 9.6757C78.2372 10.3574 78.8081 11.2607 79.2171 12.3855C79.6432 13.5103 79.8562 14.8908 79.8562 16.5269C79.8562 17.9756 79.6432 19.2623 79.2171 20.3871C78.8081 21.4949 78.2286 22.4323 77.4788 23.1992C76.7289 23.9491 75.8341 24.52 74.7945 24.912C73.7719 25.304 72.6471 25.5 71.42 25.5H67.5087V7.73282ZM71.1644 23.097C72.8346 23.097 74.1724 22.5431 75.178 21.4353C76.2005 20.3104 76.7118 18.6573 76.7118 16.4758C76.7118 14.0898 76.2176 12.4366 75.2291 11.5163C74.2406 10.596 72.9709 10.1359 71.42 10.1359H70.602V23.097H71.1644ZM91.8057 24.6308C91.3626 24.9376 90.7832 25.2017 90.0674 25.4233C89.3516 25.6449 88.508 25.7556 87.5365 25.7556C85.6107 25.7556 84.1109 25.2103 83.0372 24.1195C81.9805 23.0117 81.4522 21.3415 81.4522 19.1089C81.4522 18.1375 81.563 17.2427 81.7845 16.4247C82.0061 15.5896 82.3384 14.8823 82.7815 14.3028C83.2417 13.7063 83.8126 13.2377 84.4944 12.8968C85.1931 12.5559 86.0027 12.3855 86.923 12.3855C88.4398 12.3855 89.6498 12.8542 90.5531 13.7916C91.4734 14.7289 91.9336 16.3139 91.9336 18.5465V20.1571H84.5966C84.6648 21.2308 84.9375 22.0318 85.4147 22.5601C85.8919 23.0884 86.6844 23.3526 87.7922 23.3526C88.525 23.3526 89.2578 23.2333 89.9907 22.9947C90.7235 22.7561 91.3285 22.4749 91.8057 22.1511V24.6308ZM86.8718 14.7886C86.139 14.7886 85.5851 15.0527 85.2102 15.5811C84.8352 16.1094 84.6307 16.8848 84.5966 17.9074H88.8403V17.6518C88.8403 16.8507 88.6954 16.1776 88.4057 15.6322C88.133 15.0698 87.6217 14.7886 86.8718 14.7886ZM97.0139 7.73282V25.5H93.9717V7.73282H97.0139ZM101.072 11.0562C100.578 11.0562 100.16 10.8943 99.8196 10.5705C99.4787 10.2466 99.3083 9.81205 99.3083 9.26667C99.3083 8.73835 99.4787 8.31227 99.8196 7.98846C100.16 7.6476 100.578 7.47717 101.072 7.47717C101.566 7.47717 101.984 7.6476 102.325 7.98846C102.683 8.31227 102.862 8.73835 102.862 9.26667C102.862 9.81205 102.683 10.2466 102.325 10.5705C101.984 10.8943 101.566 11.0562 101.072 11.0562ZM99.5639 12.6412H102.606V25.5H99.5639V12.6412ZM103.75 12.6412H106.971L109.834 22.4834L112.621 12.6412H115.561L111.624 25.5H107.687L103.75 12.6412ZM126.308 24.6308C125.864 24.9376 125.285 25.2017 124.569 25.4233C123.853 25.6449 123.01 25.7556 122.038 25.7556C120.112 25.7556 118.613 25.2103 117.539 24.1195C116.482 23.0117 115.954 21.3415 115.954 19.1089C115.954 18.1375 116.065 17.2427 116.286 16.4247C116.508 15.5896 116.84 14.8823 117.283 14.3028C117.744 13.7063 118.314 13.2377 118.996 12.8968C119.695 12.5559 120.504 12.3855 121.425 12.3855C122.942 12.3855 124.152 12.8542 125.055 13.7916C125.975 14.7289 126.435 16.3139 126.435 18.5465V20.1571H119.098C119.167 21.2308 119.439 22.0318 119.916 22.5601C120.394 23.0884 121.186 23.3526 122.294 23.3526C123.027 23.3526 123.76 23.2333 124.492 22.9947C125.225 22.7561 125.83 22.4749 126.308 22.1511V24.6308ZM121.374 14.7886C120.641 14.7886 120.087 15.0527 119.712 15.5811C119.337 16.1094 119.133 16.8848 119.098 17.9074H123.342V17.6518C123.342 16.8507 123.197 16.1776 122.908 15.6322C122.635 15.0698 122.124 14.7886 121.374 14.7886ZM131.516 17.4728V25.5H128.474V12.6412H131.439L131.516 15.1976H131.592C131.95 14.3625 132.47 13.6978 133.152 13.2036C133.834 12.6923 134.609 12.4111 135.478 12.36V15.2232C134.558 15.172 133.774 15.3425 133.126 15.7344C132.479 16.1094 131.942 16.6888 131.516 17.4728ZM139.147 29.4625C138.551 29.4625 138.124 29.3858 137.869 29.2324C137.613 29.096 137.485 29.0279 137.485 29.0279V26.5481C137.656 26.7186 137.86 26.8464 138.099 26.9316C138.337 27.0168 138.593 27.0594 138.866 27.0594C139.292 27.0594 139.633 26.9657 139.888 26.7782C140.144 26.6078 140.357 26.3692 140.527 26.0624L136.105 12.6412H139.3L142.138 22.3045L144.976 12.6412H147.916L143.902 24.8098C143.476 26.1221 142.931 27.2213 142.266 28.1076C141.601 29.0108 140.562 29.4625 139.147 29.4625Z"
      fill="#21201F"
    />
    <defs>
      <clipPath id="clip0_17047_193869">
        <rect
          fill="white"
          height="28.0052"
          transform="translate(0 2.49731)"
          width="28.0052"
        />
      </clipPath>
      <clipPath id="clip1_17047_193869">
        <rect fill="white" height="28" rx="14" width="28" x="33.1172" y="2.5" />
      </clipPath>
      <clipPath id="clip2_17047_193869">
        <rect
          fill="white"
          height="24.5"
          transform="translate(32.1367 4.32007)"
          width="24.5"
        />
      </clipPath>
    </defs>
  </>,
  'DostavkaLogoWithBoxExpandedEn',
  {className: root, viewBox: '0 0 162 32'},
)
